import { queryClient } from '../../../../../App'
import { isAdmin } from '../../../../../services/AccountService'
import {
  notifyError,
  notifySuccess,
} from '../../../../../services/ToastifyService/ToastifyService'
import { singleServiceStore } from '../../../../SingleServiceRequest/stores/SingleServiceRequestStore'
import { ActiveOrder, ServiceCenterForm } from '../types/NewDrawers.types'

export const useServiceResultsHandlers = ({
  state,
  setters,
  form,
  store,
  serviceStore,
  mutations,
  resetState,
}: any) => {
  const onSendExistedRequest = async () => {
    const res = await mutations.mutateAsync({
      orderId: store.existedRequestId ?? -1,
      data: {
        receiverSerialNumber: form.watch('serialNumber'),
        serviceCenterMalfunctionId: store.serviceCenterMalfunctionId,
        serviceCenterComment: form.watch('serviceCenterComment'),
      },
    })

    handleMutationResult(
      res,
      isAdmin()
        ? serviceStore.updateCurrentServiceData
        : serviceStore.updateOrders,
      resetState,
      store.setResetAll,
      onClose,
    )
  }

  const createWithLinkToServiceRequest = async () => {
    const categories = store.createFormData?.preferentialCategories
      .map((el: any, i: number) => !!el && i)
      .filter((el: any) => typeof el === 'number')

    const body = {
      ...store.diagnosticData,
      ...store.createFormData,
      ...store.serviceCenterData,
      preferentialCategories: categories,
      senderId: store.senderId,
      incidentTypeId: store.incidentTypeId,
      malfunctionTypeId: store.malfunctionTypeId,
      installedOrderId: store.createFormData?.orderId,
      isRepeatedAppeal: store.createFormData?.isRepeatedAppeal,
      serviceCenterRequestId: state.selectedServiceRequest?.requestId,
      receiverSerialNumber: form.watch('serialNumber'),
      serviceCenterMalfunctionId: state.selectedServiceRequest?.malfunction.id!,
    }

    const res = await mutations.createWithLinkToService({ body })

    handleMutationResult(
      res,
      isAdmin()
        ? serviceStore.updateCurrentServiceData
        : serviceStore.updateOperatorsTable,
      resetState,
      store.setResetAll,
      onClose,
    )
  }

  const linkToServiceRequest = async () => {
    const res = await mutations.linkToService({
      orderId: store.existedRequestId ?? -1,
      requestId: state.selectedServiceRequest?.requestId!,
      body: {
        ReceiverSerialNumber: form.watch('serialNumber'),
        ServiceCenterMalfunctionId:
          state.selectedServiceRequest?.malfunction.id!,
      },
    })

    handleMutationResult(
      res,
      isAdmin()
        ? serviceStore.updateCurrentServiceData
        : serviceStore.updateOrders,
      resetState,
      store.setResetAll,
      onClose,
    )
  }

  const onSerialCheck = () => setters.setSerialNum(form.watch('serialNumber'))

  const onBack = () => {
    if (!store.fromExistedRequest) {
      store.setIsDiagnosticDrawerOpen(true)
    }
    store.setIsServerOrdersDrawerOpen(false)
    form.onReset()
    resetState()
  }

  const onClose = () => {
    store.setSelectedRequest(null)
    store.setCreateFormData(null)
    store.setSearchParams({})
    store.setIsServerOrdersDrawerOpen(false)
    store.setResetAll()
    store.setFromExistedRequest(false)
    store.setExistedRequestId(null)
    store.setActiveServiceOrder(null)
    resetState()
  }

  const onSubmit = (data: ServiceCenterForm) => {
    store.setServiceCenterData(data)
    store.setIsServerOrdersDrawerOpen(false)
    store.setIsCheckDrawerOpen(true)
    resetState()
  }

  const onSerialErrorBtn = () => {
    store.setServiceCenterData(form.watch())
    store.setIsServerOrdersDrawerOpen(false)
    store.setIsCheckDrawerOpen(true)
    resetState()
  }

  const getOnCheck = (request: ActiveOrder) => {
    if (state.selectedServiceRequest?.requestId === request?.requestId) {
      setters.setSelectedServiceRequest(null)
    } else {
      setters.setSelectedServiceRequest(request)
    }
  }

  return {
    onSendExistedRequest,
    createWithLinkToServiceRequest,
    linkToServiceRequest,
    onSerialCheck,
    onBack,
    onClose,
    onSubmit,
    onSerialErrorBtn,
    getOnCheck,
  }
}

const handleMutationResult = (
  res: any,
  updateFn: any,
  resetState: any,
  setResetAll: any,
  onClose: any,
) => {
  if (res?.id) {
    if (isAdmin()) {
      queryClient.invalidateQueries({ queryKey: ['service-table'] })
      queryClient.invalidateQueries({
        queryKey: ['get-service-history'],
      })
      queryClient.invalidateQueries({
        queryKey: ['get-single-service-request'],
      })
      singleServiceStore.setIsOpen(false)
    } else {
      updateFn(res)
    }

    notifySuccess('Заявка передана в сервис-центр')
    setTimeout(() => onClose(), 50)
    setResetAll()
    resetState()
  } else if (res?.validationErrors) {
    notifyError(res.validationErrors.join(', '))
  }
}
